import script from "./MainDateTimePickr.vue?vue&type=script&setup=true&lang=js"
export * from "./MainDateTimePickr.vue?vue&type=script&setup=true&lang=js"

const __exports__ = script;

export default __exports__